import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessageBroadcastService {
  private broadcastChannel = new BroadcastChannel('multiTabCommunicationChannel');
  private subjects: { [key: string]: Subject<any> } = {};
  constructor() { }

  listen() {
    this.broadcastChannel.onmessage = (result) => {
      this.emitData(result.data)
    };
  }
  broadCast(message: BroadcastModel) {
    this.broadcastChannel.postMessage(message)
  }

  private getSubject(event: string): Subject<any> {
    if (!this.subjects[event]) {
      this.subjects[event] = new Subject<any>();
    }
    return this.subjects[event];
  }
  getSubscription(event: string): Observable<any> {
    return this.getSubject(event).asObservable();
  }

  private  emitData(message: BroadcastModel) {
    this.getSubject(message.event).next(message.data);
  }
}


export type BroadcastModel = {
  event: string,
  data?: any
}